export const CHANGE_ADDRESS_SEARCH_VALUE = 'CHANGE_ADDRESS_SEARCH_VALUE';
export type CHANGE_ADDRESS_SEARCH_VALUE = typeof CHANGE_ADDRESS_SEARCH_VALUE;

export const ADDRESS_INPUT_FOCUS = 'ADDRESS_INPUT_FOCUS';
export type ADDRESS_INPUT_FOCUS = typeof ADDRESS_INPUT_FOCUS;

export const TOGGLE_SEARCH_STATUS_VALUE = 'TOGGLE_SEARCH_STATUS_VALUE';
export type TOGGLE_SEARCH_STATUS_VALUE = typeof TOGGLE_SEARCH_STATUS_VALUE;

export const LOAD_LIST_OF_OPTIONS = 'LOAD_LIST_OF_OPTIONS';
export type LOAD_LIST_OF_OPTIONS = typeof LOAD_LIST_OF_OPTIONS;

export const ON_ITEM_LIST_CLICK = 'ON_ITEM_LIST_CLICK';
export type ON_ITEM_LIST_CLICK = typeof ON_ITEM_LIST_CLICK;

export const ON_CLOSE_BUTTON = 'ON_CLOSE_BUTTON';
export type ON_CLOSE_BUTTON = typeof ON_CLOSE_BUTTON;


// WEBPACK FOOTER //
// ./src/components/AddressAutoComplete/LocalConstants.ts